export default "__VITE_ASSET__B_yCMG6U__"